import { Model } from '@vuex-orm/core'

export default class AgeGroupPolicy extends Model {
  declare id: string
  declare name?: string
  declare type: number
  declare minAge: number
  declare maxAge: number

  static entity = 'ageGroupPolicies'

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null).nullable(),
      type: this.number(0),
      minAge: this.number(0),
      maxAge: this.number(0),
    }
  }
}
